import { render, staticRenderFns } from "./WebhooksSection.vue?vue&type=template&id=01228906&scoped=true&"
import script from "./WebhooksSection.vue?vue&type=script&lang=js&"
export * from "./WebhooksSection.vue?vue&type=script&lang=js&"
import style0 from "./WebhooksSection.vue?vue&type=style&index=0&id=01228906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01228906",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VApp,VSelect,VTooltip})
